import { useEffect } from "react";
import Lenis from "lenis";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let lenisInstance = null;

export const useLenis = () => {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

        const lenis = new Lenis({
            duration: 1.2,
            lerp: 0.08,
            wheelMultiplier: 1,
            smoothWheel: true,
        });
        lenisInstance = lenis;
        if (typeof window !== "undefined") window.__lenis = lenis;

        lenis.on("scroll", ScrollTrigger.update);

        const ticker = (time) => lenis.raf(time * 1000);
        gsap.ticker.add(ticker);
        gsap.ticker.lagSmoothing(0);

        return () => {
            gsap.ticker.remove(ticker);
            lenis.destroy();
            lenisInstance = null;
        };
    }, []);
};

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisInstance) {
        lenisInstance.scrollTo(el, { offset: -80, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};
